var ContentTypeMenuButton    = require("./ContentTypeMenuButton"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind");

require("./ContentTypeMenu.less");

module.exports = kind(/** @lends  app.ProductPage.ContentTypeMenu.prototype */ {

    /**
     * @private
     */
    name: "app.ProductPage.ContentTypeMenu",

    /**
     * @private
     */
    kind: SimpleRepeater,

    /**
     * @private
     */
    classes: "app-product-page-content-type-menu",

    /**
     * The state of this menu.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * The active content type, if available.
     *
     * @type  {?Object}
     * @public
     */
    activeContentType: null,

    /**
     * Simple array support, refreshes the entire view when data changes.
     *
     * @type {enyo-ui.RepeaterArrayDataAdapter}
     * @public
     */
    dataAdapterKind: RepeaterArrayDataAdapter,

    /**
     * The kind that will be rendered for each item in the dataset.
     *
     * @type  {enyo.Control}
     * @public
     */
    childKind: ContentTypeMenuButton,

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state = this.state || {};

        this.set("data", get(state, "data.dashboard", []));
        this.set("activeContentType", state.tabData || {});
    }

});
